import { create } from 'zustand';

type RecordScope = {
    notFound: boolean;
    setNotFound: (v: boolean) => void;
    reset: () => void;
}

export const useRecordScope = create<RecordScope>((set) => ({
    notFound: false,
    setNotFound: (v) => set({ notFound: v }),
    reset: () => set({ notFound: false }),
}))